import { render, staticRenderFns } from "./CouponPrinting.vue?vue&type=template&id=145ee558&"
import script from "./CouponPrinting.vue?vue&type=script&lang=js&"
export * from "./CouponPrinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports